<template>
  <van-popup class="yuandan-dialog" :close-on-click-overlay="false" v-model="yuandanInfo.showRedpackage">
    <div class="contain-box">
      <div style="width:100%;display: flex;justify-content: flex-end;">
        <van-icon style="margin-right: 20px;margin-bottom: 15px;" name="close" color="white" size="30px" class="close-icon" @click="yuandanInfo.showRedpackage = false"></van-icon>
      </div>
      <div class="main-bg">
        <div class="list-bg">
          <div class="redpack-item-bg" v-for="item in yuandanInfo.list" :key="item.id">
            <div class="left-bg">
              <div class="left-box">
                <!-- // 卡券类型 1 加息券 2 代金券 3 满减券 -->
                <div class="left-top-box">
                  <div v-if="item.type != 1" class="unit">¥</div>
                  <div :class="item.type != 1 ? 'price' : 'price-t'">
                    {{ item.amount / 100 }}
                  </div>
                  <div v-if="item.type == 1" class="unit-precent">%</div>
                </div>

                <div v-if="item.type == 1" class="left-bottom-box">加息券</div>
              </div>
            </div>
            <div class="right-bg">
              <div class="title-txt">{{ item.condStartAmt / 1000000 }}万元起投</div>
              <div class="content-txt">
                {{ item.labelWords }}
              </div>
            </div>
            <div v-if="item.hasAward" class="btn-box-claimed"></div>
            <div v-else class="btn-box-unclaimed" @click="onImmediateClaim([item.id])"></div>
          </div>
        </div>
      </div>
      <div class="btn-bg" @click="onImmediateClaim([])"></div>
    </div>
  </van-popup>
</template>
    
<script>
import { Overlay, Icon, Popup } from "vant"

export default {
  name: "SuccessPop",
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
  },
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    yuandanInfo: {
      showRedpackage: {
        type: Boolean,
        default: false
      },
      list: []
    }
  },
  data() {
    return {}
  },
  methods: {
    clickClose() {
      this.$emit("update:visible", false)
      this.$emit("close")
    },
    onImmediateClaim(ids) {
      if (ids.length > 0) {
        this.$emit("commitUse", ids)
      } else {
        let c_ids = []
        this.yuandanInfo.list.forEach(item => {
          if (!item.hasAward) {
            c_ids.push(item.id)
          }
        })
        if (c_ids.length > 0) {
          this.$emit("commitUse", c_ids)
        } else {
          this.$toast("恭喜您，红包已全部领取完毕")
        }
        setTimeout(() => {
          this.clickClose()
        }, 3000);
      }
    }
  }
}
</script>
    
<style lang="less" scoped>
.yuandan-dialog {
  background-color: transparent;
  .contain-box {
    width: 100vw;
    height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .main-bg {
      position: relative;
      width: 100vw;
      height: 460px;
      background-image: url(../../../assets/img/pop/yuandan_bg.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .list-bg {
        position: absolute;
        top: 50px;
        left: 40px;
        right: 40px;
        bottom: 50px;
        overflow-y: scroll;
        .redpack-item-bg {
          background-image: url(../../../assets/img/pop/yuandan_item_bg.png);
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 100%;
          height: 72px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left-bg {
            margin-top: -5px;
            color: white;
            margin-left: 15px;
            .left-box {
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              .left-top-box {
                display: flex;
                justify-content: center;
                .unit {
                  font-size: 27px;
                  font-weight: 900;
                }
                .price {
                  font-size: 27px;
                  font-weight: 900;
                }
                .price-t {
                  font-size: 27px;
                  font-weight: 900;
                  margin-top: -13px;
                }
                .unit-precent {
                  font-size: 27px;
                  margin-top: -13px;
                }
              }
              .left-bottom-box {
                margin-top: -5px;
                font-size: 10px;
                border: 0.5px solid white;
                border-radius: 8px;
                padding: 0 10px;
              }
            }
          }
          .right-bg {
            margin-top: -5px;
            color: white;
            margin: 0 5px;
            border-right: 1px dashed white;
            padding-right: 10px;
            .title-txt {
              font-size: 12px;
            }
            .content-txt {
              font-size: 12px;
              // opacity: 0.8;
            }
          }
          .btn-box-unclaimed,
          .btn-box-claimed {
            margin-top: -5px;
            margin-right: 15px;
            width: 80px;
            height: 22px;

            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .btn-box-unclaimed {
            background-image: url(../../../assets/img/pop/yuandan_unclaimed.png);
          }
          .btn-box-claimed {
            background-image: url(../../../assets/img/pop/yuandan_claimed.png);
          }
        }
      }
    }
    .btn-bg {
      background-image: url(../../../assets/img/pop/yuandan_btn.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 265px;
      height: 49px;
    }
  }
}
</style>
    